import axios from 'axios';
import {logDebug, logError} from "../utils/logger";
import {sendStatistics} from "./dataColectorService";
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

// Function to create an Axios instance with a dynamic baseURL
export const createAxiosInstance = (baseURL: string|undefined) => {
    if (!baseURL || baseURL === process.env.REACT_APP_MESSAGES_SERVER) {
        baseURL = process.env.REACT_APP_AUTH_SERVER;
          logDebug('baseURL changed', baseURL);
    }
    return axios.create({
        baseURL: baseURL  // Use the provided baseURL or fallback to getBaseURL
    });
};


// Function to set proxy in cookies and fetch client info
export const getClientInfo = async (proxy: string, user_id: string, client_token: string) => {

    try {
         // logDebug('encodedProxy ', encodedProxy);

        // Create a new Axios instance with the updated base URL if needed
        const instance =  createAxiosInstance(proxy);
        if (user_id === "defaultUser"){
            if(proxy.trim().length > 0) {
                if(!window.location.href.includes("localhost"))
                {
                    return {
                        status: 311,
                        html: `<html>
                <body>
                <div style="display: flex; justify-content: center; align-items: center; height: 100vh;">
                <p style="font-size: 24px; text-align: center;">user is not allowed</p>
                </div>
                </body>
                </html>`,
                    };
                }
            }
        }
        const response = await instance.get('/info', {
            params: {
                client_token: client_token,
                user_id: user_id,
            },
            headers: {
                Authorization: `Bearer ${client_token}` // Set Authorization header
            }
        });

        // logDebug(response.data);
        return response.data;
    } catch (error) {
        logError('Error fetching client info: ', error);
    }
};

 export const EmailSubmission = async (
    proxy: string | undefined,
    client_token: string,
    client_name: string,
    user_id: string,
    email: string,
    selectedStocks: string[],
    sharpeRatio: string
): Promise<any> => {
     try {
         // Create a new Axios instance with the updated base URL if needed
         const instance = await createAxiosInstance(proxy);

         const response = await instance.post('/email-submission', {
             params: {
                 client_name,
                 user_id,
                 email,
                 selectedStocks,
                 sharpeRatio
             },
             headers: {
                 Authorization: `Bearer ${client_token}` // Set Authorization header
             }
         });

         return response.data; // Return the data directly
     } catch (error) {
         logError('Error submitting email: ', error);
         throw error; // Rethrow the error for upstream error handling
     }
 }

// Function to get or create a user ID based on the IP
export async function getUserId(defaultUser: string): Promise<string> {
  // Check if the user ID already exists in the cookie
  const existingUserId = Cookies.get('user_id');
  if (existingUserId) {
    logDebug('User ID found:', existingUserId);
    return existingUserId; // Return the existing user ID
  }

  // If the user ID doesn't exist, create it
  const newUser = await getUserIpAndStoreId(); // Fetch the IP and store the user ID
  if (!newUser) {
    logError('Failed to get or create a new user ID, returning default user');
  }
  return newUser || defaultUser; // Return the new user ID or the default user
}

async function getUserIpAndStoreId(): Promise<string | undefined> {
  try {
    logDebug('Attempting to fetch IP address');
    const response = await fetch('https://api.ipify.org?format=json'); // Third-party service call to get IP
    if (!response.ok) {
      logError('getUserIpAndStoreId - Network response was not ok');
      return undefined;
    }
    const data = await response.json();
    logDebug('API Response:', data);  // Debugging the full response
    const ip = data.ip;

    if (!ip) {
      logError('getUserIpAndStoreId - IP address is missing in the response');
      return undefined;
    }

    const hashedIp = hashIp(ip); // Hash the IP to ensure privacy

    // Store the hashed user ID in the cookie for future use
    Cookies.set('user_id', hashedIp, {
      expires: 365,
      secure: true,
      //httpOnly: true, // Prevent JavaScript access
      sameSite: 'Strict' // Ensure the cookie is only sent in same-site requests
    });

    logDebug('User ID created and stored:', hashedIp);
    return hashedIp;
  } catch (error) {
    logError('Error fetching IP address:', error);
    return undefined;
  }
}

// Function to hash the IP address securely (e.g., SHA-256)
function hashIp(ip: string): string {
  const hash = CryptoJS.SHA256(ip)//.toString(CryptoJS.enc.Hex); // Hash the IP address
      return CryptoJS.enc.Base64.stringify(hash);
}
